import { render, staticRenderFns } from "./imgurl.vue?vue&type=template&id=5a7022ea&scoped=true"
import script from "./imgurl.vue?vue&type=script&lang=js"
export * from "./imgurl.vue?vue&type=script&lang=js"
import style0 from "./imgurl.vue?vue&type=style&index=0&id=5a7022ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7022ea",
  null
  
)

export default component.exports